const trackAssetClick = (
    dataLayer: Record<string, any>[] | undefined,
    assetId: string,
    assetTitle: string
)=> {
    trackEvent(dataLayer, "asset_click", {
        asset_id: assetId,
        asset_title: assetTitle
    });
}

const trackFileDownload = (
    dataLayer: Record<string, any>[] | undefined,
    fileId: string,
    fileType: string,
    fileFormat: string,
) => {
    trackEvent(dataLayer, "download", {
        file_format: fileFormat,
        file_id: fileId,
        file_type: fileType,
    });
}

const trackFileArchiveDownload = (
    dataLayer: Record<string, any>[] | undefined,
    fileType: string,
    fileFormat: string,
    fileCategory: string,
) => {
    trackEvent(dataLayer, "download_all_media", {
        file_category: fileCategory,
        file_format: fileFormat,
        file_type: fileType,
    });
}
const trackEvent = (dataLayer: Record<string, any>[] | undefined, event: string, data: any) => {
    console.debug(`detected event "${event}":`, data);
    dataLayer?.push({event: event, ...data});
}

export {
    trackAssetClick,
    trackEvent,
    trackFileDownload,
    trackFileArchiveDownload,
}